<template>
    <div class="mb-3">
        <b-card no-body>
            <b-card-body v-if="show">
                <h3>
                    Funds: {{ (user.balance + user.credit) | formatCurrency }}
                </h3>
                <h4 class="mb-2">
                    Bill: {{ user.bill | formatCurrency }}
                    <b-badge
                        class="float-right"
                        :variant="user.enabled ? 'success' : 'danger'"
                    >
                        {{ user.enabled ? 'Active' : 'Deactivated' }}
                    </b-badge>
                </h4>
                <hr />
                <Input
                    text="Balance"
                    :value="user.balance | formatCurrency"
                    disabled
                />
                <Input
                    text="Credit"
                    :value="user.credit | formatCurrency"
                    disabled
                />
                <hr />
                <Input
                    text="Plan"
                    :value="user.plan.nickname || user.planName"
                    disabled
                />
                <Input
                    text="Charges"
                    :value="user.staticBill | formatCurrency"
                    disabled
                />
                <Input
                    v-if="user.plan.billingAmountPerGB"
                    text="Data bill"
                    :value="user.dataBill | formatCurrency"
                    disabled
                />
                <Input
                    v-if="user.plan.billingAmountPerHour"
                    text="Time bill"
                    :value="user.timeBill | formatCurrency"
                    disabled
                />
                <Input
                    v-if="user.plan.dataCap"
                    text="Data left"
                    :value="
                        (user.plan.dataCap - user.upload - user.download)
                            | formatData
                    "
                    disabled
                />
                <Input
                    v-if="user.plan.timeCap"
                    text="Time left"
                    :value="(user.plan.timeCap - user.timeUsed) | formatMinute"
                    disabled
                />
                <hr />
                <Input
                    text="Bill due"
                    :value="
                        (parseInt(user.lastBilled) +
                            parseInt(user.plan.billingInterval) * 60000)
                            | formatTimeDistance
                    "
                    disabled
                />
                <b-button block variant="primary" size="sm" to="/plans">
                    Change Plan
                </b-button>
                <b-button
                    block
                    variant="light"
                    size="sm"
                    class="mt-1"
                    v-b-modal.settle-bill
                >
                    Pay Bill &
                    {{ user.enabled ? 'Reset Usage Data' : 'Reenable' }}
                </b-button>
                <b-checkbox
                    switch
                    size="lg"
                    v-model="mutatedUser.autoRenew"
                    @change="save($event)"
                >
                    Autorenew when capped
                </b-checkbox>
            </b-card-body>
            <b-card-body v-else>
                <Spinner text="Loading" />
            </b-card-body>
            <b-card-footer>
                <b-button block variant="dark" size="sm" @click="load()">
                    Refresh
                </b-button>
            </b-card-footer>
        </b-card>
        <b-modal id="settle-bill" title="Settle bill">
            <p>
                This will apply your current bill, clear your usage records and
                attempt to start the next cycle.
            </p>
            <p>
                This action is not usually necessary, as we will apply your bill
                automatically when the due date is reached or when your bill
                exceeds your funds.
            </p>
            <p>
                If your plan has a static charge, the amount will be immediately
                added back to your bill to be resolved in the next cycle. You
                may pay more than you have to if you use this function.
            </p>
            <p>
                If your plan has a data or time cap, click "Continue" to
                reenable your account.
            </p>
            <template v-slot:modal-footer="{ close }">
                <b-button size="sm" variant="outline-danger" @click="close()">
                    Cancel
                </b-button>
                <b-button
                    size="sm"
                    variant="warning"
                    @click="
                        $store
                            .dispatch('user/user/settleBill')
                            .then(() => {
                                close()
                                load()
                                $bvToast.toast('Bill settled.', {
                                    title: 'Success',
                                    variant: 'success'
                                })
                            })
                            .catch(error => {
                                $bvToast.toast(error, {
                                    title: 'Error',
                                    variant: 'warning'
                                })
                            })
                    "
                >
                    Continue
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
    import { mapState } from 'vuex'

    import Input from '@/components/form/input'
    import Spinner from '@/components/general/spinner'

    export default {
        data() {
            return {
                mutatedUser: {},
                show: false
            }
        },
        methods: {
            load() {
                this.show = false
                this.$store.dispatch('user/user/load').then(() => {
                    this.mutatedUser = { ...this.user }
                    this.show = true
                })
            },
            save(checked) {
                this.$store
                    .dispatch('user/user/save', {
                        autoRenew: checked
                    })
                    .then(() => {
                        this.$bvToast.toast('Setting applied.', {
                            title: 'Success',
                            variant: 'success'
                        })
                    })
                    .catch(error => {
                        this.$bvToast.toast(error, {
                            title: 'Error',
                            variant: 'warning'
                        })
                    })
            }
        },
        created() {
            this.load()
        },
        components: {
            Input,
            Spinner
        },
        computed: mapState({
            user: state => state.user.user.user
        })
    }
</script>

<style lang="scss" scoped>
</style>